<template>
  <div id="location-search-and-list">
    <div id="location-input-wrapper">
      <Input
        class="scs-input"
        heading="Search for location or address"
        placeholder="Search for location"
        @scs-input="searchForLocation"
      />
    </div>
    <div id="location-search-results">
      <location-search-item
        v-if="chosenLocation"
        :title="processDBSearchResult(chosenLocation).title"
        :body="processDBSearchResult(chosenLocation).body"
        :source="processDBSearchResult(chosenLocation).source"
        selected="true"
        @click="removeLocation(chosenLocation)"
      />
      <location-search-item
        v-for="(result, index) in dbSearchResults"
        :key="index"
        :title="result.title"
        :body="result.body"
        source="db"
        @click="selectDBSearchLocation(result.location, index)"
      />
      <location-search-item
        v-for="(result, index) in awsSearchResults"
        :key="index"
        :title="result.title"
        :body="result.body"
        source="search"
        @click="selectAWSSearchLocation(result, index)"
      />
      <location-search-item
        v-for="num in loading ||
        (!searchTerm &&
          awsSearchResults.length === 0 &&
          dbSearchResults.length === 0)
          ? 5
          : 0"
        :key="num"
        source="skeleton"
      />
    </div>
  </div>
</template>
<script>
import Input from "../../../../Components/Elements/Input.vue";

import LocationSearchItem from "../../../../Components/UI/ListItems/Location/Search.vue";

export default {
  data() {
    return {
      timer: undefined,
      awsSearchResults: [],
      dbSearchResults: [],
      searchTerm: undefined,
      loading: false,
    };
  },
  methods: {
    async searchForLocation(value) {
      this.loading = true;
      this.searchTerm = value;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        if (value.length > 3) {
          await this.$store
            .dispatch("searchAWSForLocation", value)
            .then((res) => {
              this.awsSearchResults = res.map((x) => {
                return this.processAWSSearchResult(x);
              });
            });
          this.loading = false;
        }
      }, 800);
    },
    processAWSSearchResult(result) {
      let [title, ...description] = result.Text.split(", ");
      return {
        title: title,
        body: description.join(", "),
      };
    },
    processDBSearchResult(result) {
      switch (result.api_version) {
        case "9-28-2022":
          return {
            location: result,
            title: result.Name,
            body: result.Label,
            source: result.source,
          };
        default:
          // for non-api-versioned locations, result.api_version return undefined
          return {
            location: result,
            title: result.name,
            body: Object.values(result.address).reduce((acc, x) => {
              if (x) {
                return acc + ", " + x;
              } else {
                return acc;
              }
            }),
            source: "db",
          };
      }
    },
    async selectAWSSearchLocation(result, index) {
      let location = await this.$store.dispatch(
        "getAWSLocationDetails",
        result.body
      );
      location.Name = result.title;
      location.api_version = "9-28-2022";
      location.source = "search";
      this.awsSearchResults.splice(index, 1);
      this.$emit("add-location", location);
    },
    selectDBSearchLocation(result, index) {
      this.dbSearchResults.splice(index, 1);
      result.source = "db";
      this.$emit("add-location", result);
    },
    removeLocation() {
      if (this.chosenLocation.source === "db") {
        this.dbSearchResults.unshift(this.chosenLocation);
      } else {
        this.awsSearchResults.unshift(this.chosenLocation);
      }
      this.$emit("remove-location");
    },
  },
  computed: {
    chosenLocationDisplay() {
      if (this.chosenLocation) {
        return this.processDBSearchResult(this.chosenLocation);
      } else {
        return undefined;
      }
    },
  },
  created() {},
  components: {
    Input,

    LocationSearchItem,
  },
  props: ["chosenLocation"],
  emits: ["add-location", "add-location", "remove-location"],
};
</script>
<style scoped>
@media screen {
  #location-search-and-list {
    width: 100%;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #location-input-wrapper {
    width: 100%;
    /* min-width: 40%; */
    padding: 50px;
    box-sizing: border-box;
  }

  .scs-input {
    width: 100%;
  }

  #location-search-results {
    padding: 5px 25px;
    box-sizing: border-box;
    width: 100%;
    height: 350px;
    overflow: scroll;
  }
  @media (min-width: 800px) {
    #location-search-and-list {
      height: 100%;
      flex-direction: row;
    }
    #location-input-wrapper {
      width: 40%;
      min-width: 40%;
      border-right: 2px solid var(--contrastColor);

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    #location-search-results {
      padding: 5px 50px;
      width: 60%;
      min-width: 560px;
      height: 350px;
    }
  }
}
</style>
